import React, { useState, useRef } from "react"

import { concatClassNames } from "helpers/jsxHelpers"
import IfChildren from "components/Shared/IfChildren"

import "./MetricCard.styles.scss"
import { InfoCircle } from "@walmart-web/livingdesign-icons"
import { IconButton, Popover } from "@walmart-web/livingdesign-components"

type MetricCardProps = {
	chart?: React.ReactNode
	className?: string
	details?: React.ReactNode
	style?: React.CSSProperties
	title?: string
	content?: string
}

const MetricCard = (props: MetricCardProps) => {
	const { title, content, chart, details, className, style } = props
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const iconRef = useRef<HTMLButtonElement>(null)

	return (
		<div
			className={concatClassNames(["base-metric-card", className])}
			style={style}
		>
			<IfChildren as="span" className="base-metric-card__title">
				{title}
				<Popover
					content={<div className="popover-content">{content}</div>}
					onClose={() => setIsOpen(false)}
					triggerRef={iconRef}
					position="top"
					hasNubbin
					isOpen={isOpen}
				>
					<IconButton
						UNSAFE_className="popover-button"
						a11yLabel="popover-button"
						onClick={() => setIsOpen(true)}
						ref={iconRef}
						size="medium"
					>
						<InfoCircle />
					</IconButton>
				</Popover>
			</IfChildren>
			<IfChildren className="base-metric-card__chart">{chart}</IfChildren>
			<IfChildren className="base-metric-card__details">{details}</IfChildren>
		</div>
	)
}

export default MetricCard
